export enum DomainAggregateWorkspaceCapabilityUdoTemplateKey {
    template = "7aee98bc-2076-4282-b150-e479db3adabe",
}
